// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import {useAuth } from '../context/AuthContext';
// import "./InviteParticipantsPage.css";


// const SurveyInvitePage = () => {

//   const { user } = useAuth();


//   const {surveyId} = useParams();
//   const {companyId} = useParams();
//     console.log(`company id is ${companyId}`)

//   // 🧠 Replace with your known company_fk (you might pass it as prop or env var)
//   const company_fk = process.env.REACT_APP_COMPANY_ID || 1; // example fallback

//   const [email, setEmail] = useState("");
//   const [subject, setSubject] = useState("You're invited to take our survey!");
//   const [body, setBody] = useState("");
//   const [departments, setDepartments] = useState([]);
//   const [selectedDept, setSelectedDept] = useState("");
//   const [surveyLink, setSurveyLink] = useState("");
//   const [copied, setCopied] = useState(false);

//   // 🔹 Fetch departments for the given company_fk
//   const fetchDepartments = async () => {
//     try {
//       const res = await axios.get(
//         // `${process.env.REACT_APP_API_BASE_URL}/departments?company_fk=${company_fk}`
//                 `${process.env.REACT_APP_API_BASE_URL}/departments?company_fk=${companyId}`
//       );
//       setDepartments(res.data || []);
//     } catch (err) {
//       console.error("Error fetching departments:", err);
//     }
//   };

//   // 🔹 On mount, fetch departments
//   useEffect(() => {
//     fetchDepartments();
//   }, []);

//   // 🔹 Generate email body & survey link dynamically
//   useEffect(() => {
//     const baseUrl = window.location.origin;
//     // const link = `${baseUrl}/survey/${surveyId}?company_fk=${user.company_fk}`
// // 🔹 Build payload with BOTH values
// const payload = {
//   surveyId,
//   company_fk:companyId,
// };

// // 🔹 Encode as deterministic Base64
// const json = JSON.stringify(payload);
// const token = btoa(encodeURIComponent(json)); // deterministic, no expiry

// // 🔹 Final link
// const link = `${baseUrl}/survey/${token}`;
// setSurveyLink(link);


//     setSurveyLink(link);

//     const emailBody = `Hello,

// We’d love to hear your thoughts! Please take a few minutes to complete our survey.

// Click below to start:
// ${link}

// Thank you,
// The Team`;

//     setBody(emailBody);
//   }, [surveyId, selectedDept]);

//   // 🔹 Copy to clipboard
//   const handleCopyLink = () => {
//     navigator.clipboard.writeText(surveyLink);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 1500);
//   };

//   // 🔹 Placeholder send invitation handler
//   const handleSendInvitation = (e) => {
//     e.preventDefault();
//     console.log("Email:", email);
//     console.log("Subject:", subject);
//     console.log("Body:", body);
//     console.log("Department:", selectedDept);
//     alert("Invitation sending not implemented yet 🚧");
//   };

//   return (
//     <div className="invite-container">
//       <div className="invite-card">
//         <h2 className="invite-title">📧 Send Survey Invitation</h2>

//         <form className="invite-form" onSubmit={handleSendInvitation}>
//           {/* Email Field */}
//           <label>Email Address</label>
//           <input
//             type="email"
//             placeholder="Enter recipient's email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />

//           {/* Department Dropdown */}
//           {/* <label>Department</label>
//           <select
//             value={selectedDept}
//             onChange={(e) => setSelectedDept(e.target.value)}
//           >
//             <option value="">-- Select Department --</option>
//             {departments.map((dept) => (
//               <option key={dept.id} value={dept.id}>
//                 {dept.name}
//               </option>
//             ))}
//           </select> */}

//           {/* Subject */}
//           <label>Subject</label>
//           <input
//             type="text"
//             placeholder="Enter email subject"
//             value={subject}
//             onChange={(e) => setSubject(e.target.value)}
//             required
//           />

//           {/* Body */}
//           <label>Email Body</label>
//           <textarea
//             value={body}
//             onChange={(e) => setBody(e.target.value)}
//             rows={8}
//           ></textarea>

//           {/* Preview */}
//           <div className="preview-section">
//             <p>📎 <strong>Preview:</strong></p>
//             <div className="email-preview">
//               {body.split("\n").map((line, idx) => (
//                 <p key={idx}>
//                   {line.includes("http") ? (
//                     <a href={line} target="_blank" rel="noopener noreferrer">
//                       {line}
//                     </a>
//                   ) : (
//                     line
//                   )}
//                 </p>
//               ))}
//             </div>
//           </div>

//           {/* Generated Link + Copy */}
//           <div className="generated-link">
//             <label>Generated Link:</label>
//             <div className="link-row">
//               <input type="text" value={surveyLink} readOnly />
//               <button type="button" className="copy-btn" onClick={handleCopyLink}>
//                 {copied ? "✅ Copied!" : "📋 Copy"}
//               </button>
//             </div>
//           </div>

//           <button type="submit" className="send-btn" disabled>
//             Send Invitation
//           </button>
//           <p className="coming-soon">🔒 Email sending feature coming soon</p>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SurveyInvitePage;


import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from '../context/AuthContext';
import "./InviteParticipantsPage.css";

const SurveyInvitePage = () => {
  const { user } = useAuth();
  const { surveyId, companyId } = useParams();
  
  // ✅ Detect if this is a public/individual survey
  const isIndividual = String(companyId) === "0";

  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState(isIndividual ? "You're invited to take our public survey!" : "You're invited to take our survey!");
  const [body, setBody] = useState("");
  const [departments, setDepartments] = useState([]);
  const [surveyLink, setSurveyLink] = useState("");
  const [copied, setCopied] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const [qrLoading, setQrLoading] = useState(false);

  // ── TTL (Time-to-Live) for the survey link ──
  const [ttlOption, setTtlOption] = useState("24");   // "24" | "48" | "custom" | "unlimited"
  const [customHrs, setCustomHrs] = useState(72);

  // Effective hours derived from selection
  const effectiveHours =
    ttlOption === "unlimited" ? null
    : ttlOption === "custom" ? Number(customHrs) || 24
    : Number(ttlOption);

  // 🔹 Fetch departments (ONLY if it's a company survey)
  const fetchDepartments = async () => {
    if (isIndividual) return; // Skip for public surveys

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/departments?company_fk=${companyId}`);
      setDepartments(res.data || []);
    } catch (err) {
      console.error("Error fetching departments:", err);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [companyId]);

  // 🔹 Fetch QR Code when surveyLink changes
  useEffect(() => {
    if (!surveyLink) return;
    const fetchQr = async () => {
      setQrLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/survey/qr?url=${encodeURIComponent(surveyLink)}`
        );
        setQrCode(res.data.qr);
      } catch (err) {
        console.error("Failed to generate QR Code:", err);
      } finally {
        setQrLoading(false);
      }
    };
    fetchQr();
  }, [surveyLink]);

  // 🔹 Generate email body & survey link dynamically
  useEffect(() => {
    const baseUrl = window.location.origin;
    
    // 🔹 Build payload
    const payload = {
      surveyId,
      company_fk: String(companyId),
    };

    // ✅ Add expiration timestamp using the selected TTL
    if (isIndividual && effectiveHours !== null) {
      payload.expiresAt = Date.now() + effectiveHours * 60 * 60 * 1000;
    }

    // 🔹 Encode as Base64
    const json = JSON.stringify(payload);
    const token = btoa(encodeURIComponent(json)); 
    
    // 🔹 Final link
    const link = `${baseUrl}/survey/${token}`;
    setSurveyLink(link);

    const emailBody = `Hello,

We’d love to hear your thoughts! Please take a few minutes to complete our survey.

Click below to start:
${link}

${isIndividual ? (effectiveHours !== null ? `(Note: This link will expire in ${effectiveHours} hours for security purposes.)\n` : `(Note: This link does not expire.)\n`) : ""}
Thank you,
The Team`;

    setBody(emailBody);
  }, [surveyId, companyId, isIndividual, effectiveHours]);

  // 🔹 Copy to clipboard
  const handleCopyLink = () => {
    navigator.clipboard.writeText(surveyLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleSendInvitation = (e) => {
    e.preventDefault();
    console.log("Email:", email);
    console.log("Subject:", subject);
    console.log("Body:", body);
    alert("Invitation sending not implemented yet 🚧");
  };

  return (
    <div className="invite-container">
      <div className="invite-card">
        <h2 className="invite-title">
          {isIndividual ? "🌐 Invite to Public Survey" : "📧 Send Company Invitation"}
        </h2>

        <form className="invite-form" onSubmit={handleSendInvitation}>

          {/* ── TTL Selector (individual/public surveys only) ── */}
          {isIndividual && (
            <div style={{ background: "#f0f9ff", border: "1px solid #bae6fd", borderRadius: "8px", padding: "12px 14px", marginBottom: "12px" }}>
              <label style={{ fontWeight: 700, fontSize: "13px", color: "#0369a1", display: "block", marginBottom: "8px" }}>
                ⏱️ Link Expiry (Time to Live)
              </label>
              <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                <select
                  value={ttlOption}
                  onChange={e => setTtlOption(e.target.value)}
                  style={{ padding: "7px 10px", borderRadius: "6px", border: "1px solid #7dd3fc", fontSize: "13px", background: "#fff", cursor: "pointer" }}
                >
                  <option value="24">24 hours (default)</option>
                  <option value="48">48 hours</option>
                  <option value="custom">Custom hours</option>
                  <option value="unlimited">Unlimited (no expiry)</option>
                </select>

                {ttlOption === "custom" && (
                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <input
                      type="number"
                      min={1}
                      max={8760}
                      value={customHrs}
                      onChange={e => setCustomHrs(e.target.value)}
                      style={{ padding: "7px 10px", borderRadius: "6px", border: "1px solid #7dd3fc", fontSize: "13px", width: "80px" }}
                      placeholder="e.g. 72"
                    />
                    <span style={{ fontSize: "12px", color: "#64748b" }}>hours</span>
                  </div>
                )}

                <span style={{ fontSize: "12px", color: "#0369a1", background: "#e0f2fe", padding: "3px 10px", borderRadius: "999px", fontWeight: 600 }}>
                  {effectiveHours !== null ? `Link valid for ${effectiveHours} hr${effectiveHours !== 1 ? "s" : ""}` : "Link never expires"}
                </span>
              </div>
            </div>
          )}

          <label>Email Address</label>
          <input
            type="email"
            placeholder="Enter recipient's email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Subject</label>
          <input
            type="text"
            placeholder="Enter email subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />

          <label>Email Body</label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={10}
          ></textarea>

          <div className="preview-section">
            <p>📎 <strong>Preview:</strong></p>
            <div className="email-preview">
              {body.split("\n").map((line, idx) => (
                <p key={idx}>
                  {line.includes("http") ? (
                    <a href={line} target="_blank" rel="noopener noreferrer">{line}</a>
                  ) : line}
                </p>
              ))}
            </div>
          </div>

          <div className="generated-link">
            <label>Generated Link:</label>
            <div className="link-row">
              <input type="text" value={surveyLink} readOnly />
              <button type="button" className="copy-btn" onClick={handleCopyLink}>
                {copied ? "✅ Copied!" : "📋 Copy"}
              </button>
            </div>
          </div>

          {surveyLink && (
            <div className="qr-container">
              <label>Survey QR Code:</label>
              {qrLoading ? (
                <div className="qr-placeholder">
                  <div className="qr-spinner"></div>
                  <span>Generating QR Code...</span>
                </div>
              ) : qrCode ? (
                <div className="qr-box">
                  <img src={qrCode} alt="Survey QR Code" className="qr-image" />
                  <button
                    type="button"
                    className="download-qr-btn"
                    onClick={() => {
                      const linkElement = document.createElement("a");
                      linkElement.href = qrCode;
                      linkElement.download = `survey-${surveyId}-${companyId}-qr.png`;
                      linkElement.click();
                    }}
                  >
                    💾 Download QR Code (PNG)
                  </button>
                </div>
              ) : (
                <div className="qr-error">Failed to generate QR Code.</div>
              )}
            </div>
          )}

          <button type="submit" className="send-btn" disabled>
            Send Invitation
          </button>
          <p className="coming-soon">🔒 Email sending feature coming soon</p>
        </form>
      </div>
    </div>
  );
};

export default SurveyInvitePage;